import { TFunction } from 'i18next';

import { ChampionshipStageTab } from 'modules/championship/domain/enums/championship-stage-tab';

/**
 * Порядок вкладок этапа в `TabMenu`. `undefined` — «Редактирование»: своего
 * сегмента у неё нет, это корень `/steps/:stageId`.
 */
export const STAGE_TAB_ORDER: (ChampionshipStageTab | undefined)[] = [
  undefined,
  ChampionshipStageTab.TEAMS,
  ChampionshipStageTab.GRID,
  ChampionshipStageTab.MATCHES,
];

/** Индекс динамической вкладки «Матч: A - B» — она появляется только на странице матча. */
export const STAGE_MATCH_TAB_INDEX = STAGE_TAB_ORDER.length;

/**
 * Подпись подвкладки этапа. Одно место на таб-бар и хлебные крошки — иначе они
 * разъезжаются.
 */
export const getStageTabLabel = (t: TFunction, tab: ChampionshipStageTab | undefined): string =>
  t(`championship.stageTabs.${tab ?? 'info'}`);
